const switchTab = (event: Event): void => {
  const clickedElement = event.currentTarget as HTMLButtonElement

  const tabs = document.querySelectorAll<HTMLButtonElement>('[data-switchable]')

  tabs.forEach((singleTab) => {
    singleTab.hidden = true
  })

  const tabToSwitch = document.querySelector<HTMLElement>(
    `[data-switchable='${clickedElement.getAttribute('data-switch-tab')}']`,
  )

  const buttons = document.querySelectorAll<HTMLButtonElement>('[data-switch-tab]')
  buttons.forEach((singleButton) => {
    singleButton.classList.remove('is-active')
  })

  tabToSwitch.hidden = false
  clickedElement.classList.add('is-active')
}

export function initTabSwitching(): void {
  const buttons = document.querySelectorAll<HTMLButtonElement>('[data-switch-tab]')
  buttons.forEach((singleButton) => {
    singleButton.addEventListener('click', switchTab)
  })
}
